import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from 'src/app/shared/guard/authentication-guard';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
import { Entity, HeaderMenuType } from 'src/app/shared/store/view/types';
import { HasUnsavedChangesGuard } from '../../shared/guard/has-form-changed.guard';

const routes: Routes = [
  {
    path: 'Home',
    component: HomeLayoutComponent,
    canActivate: [AuthenticationGuard],
    canDeactivate: [HasUnsavedChangesGuard],
    canActivateChild: [],
    data: {
      title: 'APP_TITLE_HOME',
      header: 'HEADER_SUBTITLE_HOME',
      headerMenu: HeaderMenuType.Home,
      entity: Entity.Home,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
